import React, {memo, useCallback, FC} from "react";
import {useDispatch} from "react-redux";
import {ExtraActionsMenu} from "./extraActionsMenu/extraActionsMenu";
import {cardViewActions} from "../cardView.slice";
import {CardActionBarProps} from "./cardActionBar.interface";
import styled from "styled-components";
import { ThemeProps } from "../../../styles/theme";
import { styleConstants } from "../../../styles/styleConstants";
import { uiActions } from "../../../ui/ui.slice";
import { SideMenu } from "../../../review/sideMenu/sideMenu";

const Root = styled.div<ThemeProps>`
    background-color: ${props => props.theme.secondaryBackground};
    border: ${props => props.theme.secondaryBorder} 1px solid;
    position: sticky;
    top: 0;
    height: 48px;
    width: 100%;
    z-index: 10;
`;

const MenuLayer = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
`;

const LeftSection = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const RightSection = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 10px;
`;

const Icon = styled.svg<ThemeProps>`
    height: ${styleConstants.actionBarIconSize};
    width: ${styleConstants.actionBarIconSize};
    fill: ${props => props.theme.secondaryIcon};
    cursor: pointer;
`;

const CardActionBarComponent: FC<CardActionBarProps> = props => {
    const dispatch = useDispatch();

    const menuHandler = useCallback(() => {
        dispatch(uiActions.openSideMenu());
    }, [dispatch]);

    const extraActionsHandler = useCallback(() => {
        dispatch(cardViewActions.openExtraActionsMenu());
    }, [dispatch]);

    return (
        <Root>
            <MenuLayer>
                <LeftSection>
                    <Icon onClick={menuHandler} viewBox="0 0 24 24">
                        <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
                    </Icon>
                </LeftSection>
                <RightSection>
                    <Icon onClick={extraActionsHandler} data-testid="card-actions" viewBox="0 0 24 24">
                        <path d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                    </Icon>
                </RightSection>
            </MenuLayer>
            <SideMenu />
            <ExtraActionsMenu
                cardId={props.cardId}
            />
        </Root>
    );
};
CardActionBarComponent.displayName = 'CardActionBarComponent';

export const CardActionBar : FC<CardActionBarProps> = memo(CardActionBarComponent);
CardActionBar.displayName = 'CardActionBar';
